// extracted by mini-css-extract-plugin
export var externalLink = "_bp-0";
export var internalLinkLabel = "_bp-1";